import { Input, DatePicker } from "antd";
import { Control, FieldValues } from "react-hook-form";
import { FormItem, FormItemProps } from "react-hook-form-antd";

interface IObjectFormInputDate<T extends FieldValues> {
  nameFirst: FormItemProps<T>["name"];
  nameSecond: FormItemProps<T>["name"];
  control: Control<T>;
  labelFirst?: string;
  labelSecond?: string;
  placeholderFirst?: string;
  placeholderSecond?: string;
}

export function ObjectFormInputDate<T extends FieldValues>({
  nameFirst,
  nameSecond,
  control,
  labelFirst,
  labelSecond,
  placeholderFirst,
  placeholderSecond,
}: IObjectFormInputDate<T>) {
  return (
    <div className="field-group">
      <FormItem
        control={control}
        name={nameFirst}
        label={labelFirst}
        style={{ margin: 0 }}
      >
        <Input placeholder={placeholderFirst} className="object-form-input" />
      </FormItem>
      <FormItem
        control={control}
        name={nameSecond}
        label={labelSecond}
        style={{ margin: 0 }}
      >
        <DatePicker
          placeholder={placeholderSecond}
          className="object-form-input"
          format="DD.MM.YYYY"
        />
      </FormItem>
    </div>
  );
}
